import { Injectable, inject } from '@angular/core';
import { IPlano } from '@nomoh-monorepo/shared-types';
import { PlanosDataService } from './feature-planos.dataservice.service';

@Injectable({ providedIn: 'root' })
export class PlanosService {
  private planosDataService = inject(PlanosDataService);

  // PRINCÍPIO KISS: Component injeta DataService diretamente para signals
  // Service apenas para business logic com validações

  async carregarPlanos(): Promise<void> {
    // Business logic: Validar permissão (quando disponível)
    // await this.permissionService.validarPermissao('planos.read');

    return this.planosDataService.carregarPlanos();
  }

  async buscarPlanos(
    nome?: string | null,
    sistemaId?: string | null
  ): Promise<void> {
    // await this.permissionService.validarPermissao('planos.read');

    return this.planosDataService.buscar(nome, sistemaId);
  }

  async criarPlano(plano: Omit<IPlano, 'id'>): Promise<string | null> {
    // Business logic: Validar permissão crítica
    // await this.permissionService.validarPermissao('planos.create');

    // Validações de negócio
    if (!plano.nome || plano.nome.trim().length === 0) {
      throw new Error('Nome do plano é obrigatório');
    }

    if (!plano.sistemaId || plano.sistemaId.trim().length === 0) {
      throw new Error('Sistema/Aplicação é obrigatório');
    }

    return this.planosDataService.criarPlano(plano);
  }

  async atualizarPlano(plano: IPlano): Promise<boolean> {
    // await this.permissionService.validarPermissao('planos.update');

    // Validações de negócio
    if (!plano.id || plano.id.trim().length === 0) {
      throw new Error('ID do plano é inválido');
    }

    if (!plano.nome || plano.nome.trim().length === 0) {
      throw new Error('Nome do plano é obrigatório');
    }

    if (!plano.sistemaId || plano.sistemaId.trim().length === 0) {
      throw new Error('Sistema/Aplicação é obrigatório');
    }

    return this.planosDataService.atualizarPlano(plano);
  }

  async excluirPlano(id: string): Promise<boolean> {
    // await this.permissionService.validarPermissao('planos.delete');

    // Validação de negócio
    if (!id || id.trim().length === 0) {
      throw new Error('ID do plano é inválido');
    }

    // Confirmação adicional pode ser feita no componente
    return this.planosDataService.excluirPlano(id);
  }

  async buscarPorId(id: string): Promise<IPlano | null> {
    // await this.permissionService.validarPermissao('planos.read');

    if (!id || id.trim().length === 0) {
      throw new Error('ID do plano é inválido');
    }

    return this.planosDataService.buscarPorId(id);
  }

  // Métodos de navegação (sem validação adicional necessária)
  async proximaPagina(): Promise<void> {
    return this.planosDataService.proximaPagina();
  }

  async paginaAnterior(): Promise<void> {
    return this.planosDataService.paginaAnterior();
  }

  async irParaPagina(pagina: number): Promise<void> {
    return this.planosDataService.irParaPagina(pagina);
  }

  async limparFiltros(): Promise<void> {
    return this.planosDataService.limparFiltros();
  }

  // ========================================
  // OPERAÇÕES DE PERMISSÕES DO PLANO
  // ========================================

  async buscarPermissoesPlano(planoId: string): Promise<{
    planoId: string;
    permissions: Array<{
      id: string;
      key: string;
      module: string;
      action: string;
      description: string;
      availabilityId: string;
    }>;
    total: number;
  } | null> {
    // Validação de negócio
    if (!planoId || planoId.trim().length === 0) {
      throw new Error('ID do plano é inválido');
    }

    return this.planosDataService.buscarPermissoesPlano(planoId);
  }

  async adicionarPermissoesPlano(
    planoId: string,
    availabilityIds: string[]
  ): Promise<boolean> {
    // Validações de negócio
    if (!planoId || planoId.trim().length === 0) {
      throw new Error('ID do plano é inválido');
    }

    if (!availabilityIds || availabilityIds.length === 0) {
      throw new Error('Nenhuma permissão selecionada');
    }

    return this.planosDataService.adicionarPermissoesPlano(
      planoId,
      availabilityIds
    );
  }

  async removerPermissoesPlano(
    planoId: string,
    availabilityIds: string[]
  ): Promise<boolean> {
    // Validações de negócio
    if (!planoId || planoId.trim().length === 0) {
      throw new Error('ID do plano é inválido');
    }

    if (!availabilityIds || availabilityIds.length === 0) {
      throw new Error('Nenhuma permissão selecionada');
    }

    return this.planosDataService.removerPermissoesPlano(
      planoId,
      availabilityIds
    );
  }
}
